import React from "react"
import clsx from "clsx"
import IcoMoon from "react-icomoon"
import { Row } from "ui/components/atoms/_atoms"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Icon.module.css"
import iconSet from "./selection.json"

export const IconBox = ({
  icon,
  $size = 40,
  $small = false,
  $color = "primary",
  $background = "primaryBackground",
  ...rest
}: BaseStyles & {
  icon: string
  $size?: number
  $small?: boolean
}) => {
  const finalSize = $small ? 25 : $size

  return (
    <Row
      $width={`${finalSize}px`}
      $height={`${finalSize}px`}
      $background={$background}
      $alignItems="center"
      $justifyContent="center"
      $borderRadius="50%"
      {...rest}
    >
      <Icon icon={icon} $size={`${finalSize / 2}px`} $color={$color} />
    </Row>
  )
}

const Icon = ({
  icon,
  className = "",
  $size,
  $color = "secondary",
  style = {},
  ...props
}: BaseStyles & {
  icon: string
  className?: string
  $size?: string | number
  style?: React.CSSProperties
}) => {
  const generatedStyles = generateStylesFromProps({ ...props, $color, $size })

  const iconClasses = clsx(styles.icon, className)

  const iconStyles = {
    ...generatedStyles,
    ...style,
  }

  return <IcoMoon icon={icon} className={iconClasses} iconSet={iconSet} style={iconStyles} />
}

export default Icon
